__turbopack_context__.v({
  "chevron": "language-filter-module-scss-module__zG5hwa__chevron",
  "chevronDown": "language-filter-module-scss-module__zG5hwa__chevronDown",
  "languageFilterContainer": "language-filter-module-scss-module__zG5hwa__languageFilterContainer",
  "languageFilterControl": "language-filter-module-scss-module__zG5hwa__languageFilterControl",
  "languageFilterControlText": "language-filter-module-scss-module__zG5hwa__languageFilterControlText",
  "languageFilterDescription": "language-filter-module-scss-module__zG5hwa__languageFilterDescription",
  "languageFilterIcon": "language-filter-module-scss-module__zG5hwa__languageFilterIcon",
  "languageFilterIndicatorSeparator": "language-filter-module-scss-module__zG5hwa__languageFilterIndicatorSeparator",
  "languageFilterLanguage": "language-filter-module-scss-module__zG5hwa__languageFilterLanguage",
  "languageFilterMenuCheckbox": "language-filter-module-scss-module__zG5hwa__languageFilterMenuCheckbox",
  "languageFilterMenuItem": "language-filter-module-scss-module__zG5hwa__languageFilterMenuItem",
  "languageFilterMenuList": "language-filter-module-scss-module__zG5hwa__languageFilterMenuList",
  "languageFilterValueContainerContents": "language-filter-module-scss-module__zG5hwa__languageFilterValueContainerContents",
  "svg": "language-filter-module-scss-module__zG5hwa__svg",
  "wrapper": "language-filter-module-scss-module__zG5hwa__wrapper",
});
